<script lang="ts" setup>
import { computed, useCssModule } from 'vue';
import type { RouteLocationRaw } from 'vue-router';

interface Props {
  variant?: 'primary' | 'secondary';
  href?: string | RouteLocationRaw;
  type?: 'button' | 'submit';
}

const props = withDefaults(defineProps<Props>(), {
  variant: 'primary',
  type: 'button',
});

const css = useCssModule('css');

const classes = computed(() => {
  return [css.button, props.variant === 'secondary' && css.secondary];
});
</script>

<template>
  <RouterLink
    v-if="typeof href === 'object'"
    :to="href"
    :class="classes"
  >
    <slot />
  </RouterLink>

  <a
    v-else-if="href"
    :href="href"
    :class="classes"
  >
    <slot />
  </a>

  <button
    v-else
    :class="classes"
    :type="type"
  >
    <slot />
  </button>
</template>

<style lang="scss" module="css">
.button {
  display: inline-block;
  padding: 0.75rem 1.5rem;
  border: 1px solid $color-patient-950;
  border-radius: $radius-full;
  background: $color-patient-950;
  color: $color-white;
  text-decoration: none;
  width: auto;
  font-family: inherit;
  font-size: inherit;
  cursor: pointer;
  transition: all $transition-duration $transition-ease-out-quad;

  &:hover,
  &:focus {
    background: $color-gray-600;
    color: $color-white;
    border-color: $color-gray-600;
  }
}

.secondary {
  background: transparent;
  color: $color-patient-950;
  border-color: $color-patient-950;

  &:hover,
  &:focus {
    background: $color-patient-950;
    color: $color-white;
  }
}
</style>
